import { paths } from 'src/compass/site/routes/paths';
import useUpdateMutation from 'src/compass/shared/hooks/reactQuery/useUpdateMutation';
import { onSuccessEnqueueSnackbar } from 'src/compass/shared/util/onSuccessEnqueueSnackbar';

// Starting or stopping reloads the app, so the menus, permissions and every cached query are
// fetched again as the new user.
const reloadAtHome = (response: any) => {
  onSuccessEnqueueSnackbar(response);
  window.location.href = paths.home;
};

const reloadCurrentPage = (response: any) => {
  onSuccessEnqueueSnackbar(response);
  window.location.reload();
};

/**
 * Admins and Support users; the backend checks which users each may pick. `stayOnPage` reloads the
 * current page instead of Home - one the impersonated user can't open shows Page Not Found.
 */
export function useImpersonate({ stayOnPage = false } = {}) {
  const { mutate, isPending } = useUpdateMutation({
    url: 'Login/Impersonate',
    onSuccess: stayOnPage ? reloadCurrentPage : reloadAtHome,
  });

  return { impersonate: (userId: number) => mutate({ userId }), isPending };
}

export function useStopImpersonating() {
  const { mutate, isPending } = useUpdateMutation({
    url: 'Login/StopImpersonate',
    onSuccess: reloadAtHome,
  });

  return { stopImpersonating: () => mutate(), isPending };
}
